import Button from "components/components/Button/Button";
import Modal, { ModalSize } from "components/components/Modal/Modal";
import {
  ButtonDiv,
  Header,
  HeaderRow,
  Content,
} from "components/components/balancingMechanism/balancingMechanismTabs/descriptionModals/style";
import React from "react";

export interface ModalProps {
  isOpen: boolean;
  close: () => void;
}

interface Props extends ModalProps {
  headingId: string;
  title: string;
  children: JSX.Element;
}

const TabModal: React.FC<Props> = ({
  isOpen,
  close,
  headingId,
  title,
  children,
}) => (
  <Modal
    size={ModalSize.xLarge}
    isActive={isOpen}
    onClose={close}
    headingId={headingId}
  >
    <Content>
      <HeaderRow>
        <Header id={headingId}>{title}</Header>
        <ButtonDiv>
          <Button ariaLabel="Close" buttonText="Close" onClick={close} />
        </ButtonDiv>
      </HeaderRow>
      {children}
    </Content>
  </Modal>
);

export default TabModal;
